export const initialize = {
  basket: []
};

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TO_BASKET": {
      const incoming = action.item;
      const qtyToAdd = incoming.quantity && Number(incoming.quantity) > 0 ? Number(incoming.quantity) : 1;

      const exists = state.basket.some(item => item.id === incoming.id);

      if (exists) {
        return {
          ...state,
          basket: state.basket.map(item =>
            item.id === incoming.id
              ? { ...item, quantity: item.quantity + qtyToAdd }
              : item
          )
        };
      }

      return {
        ...state,
        basket: [...state.basket, { ...incoming, quantity: qtyToAdd }]
      };
    }

    case "Increase_TO_BASKET":
      return {
        ...state,
        basket: state.basket.map(item =>
          item.id === action.item.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      };

    case "Decrease_TO_BASKET":
      return {
        ...state,
        basket: state.basket.map(item =>
          item.id === action.item.id && item.quantity > 1
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      };

    case "REM_FROM_BASKET":
      return {
        ...state,
        basket: state.basket.filter(item => item.id !== action.item.id)
      };

    default:
      return state;
  }
};

export default reducer;